import Highcharts from 'highcharts';
export function drawPieChart(response){

    Highcharts.chart('canvas', {
                        chart: {
                            plotBackgroundColor: null,
                            plotBorderWidth: null,
                            plotShadow: false,
                            type: 'pie'
                        },
                        title:{
                            text:''
                        },
                        credits: {
                            enabled: false
                        },
                        tooltip: {
                            pointFormat: '{point.y}: <b>{point.percentage:.1f}%</b>'
                        },
                        plotOptions: {
                            pie: {
                                allowPointSelect: true,
                                cursor: 'pointer',
                                startAngle :320,
                                dataLabels: {
                                    enabled: true,
                                    format: '<b>{point.name}</b>: {point.percentage:.1f} %'
                                }
                            }
                        },
                        series: [{
                            name: 'Brands',
                            colorByPoint: true,
                            data: [{
                                name: 'Interest Amount',
                                y: response.interestAmount,
                                color:'#43AB51'
                            }, {
                                name: 'Principal Amount',
                                y: response.loanAmount,
                                color: '#018BCF'
                            }]
                        }]
                    });
    

}